import * as React from "react";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";

const THEMEURL = window.drupalSettings
  ? window.drupalSettings.path.themeUrl
  : "themes/custom/mx_aguas_firmes_theme";
declare global {
  interface Window {
    a2a_config: any;
  }
}
const textShare =
  "Te invitamos a votar por este gran dibujo en nuestra pagina web. El ganador verá su obra expuesta en el mural";
window.a2a_config.templates.facebook = {
  quote: textShare,
};
window.a2a_config.templates.twitter = {
  text: textShare + " ${link}",
};
window.a2a_config.templates.whatsapp = {
  text: textShare + " ${link}",
};
export default ({ data, onClick, dataAos }: any) => {
  const [isClickLike, setIsClickLike] = React.useState<any>(false);

  const reanimate = () => {
    let refMainCard: HTMLElement = document.querySelector(".af-draw-preview");
    if (refMainCard) {
      refMainCard.style.transitionDuration = "0s";
      refMainCard.classList.remove("aos-animate");
      setTimeout(() => {
        refMainCard.removeAttribute("style");
        onClick && onClick(data);
        refMainCard.classList.add("aos-animate");
      }, 100);
      return;
    }
    onClick && onClick(data);
  };

  const handleClickLike = (id: any) => {
    setIsClickLike(true);
    sendVote(id);
  };

  const sendVote = (index: number) => {
    if (window.drupalSettings.user.uid <= 0) {
      window.location.href = "/inicio-sesion";
    } else {
      const API_URL =
        window.location.protocol +
        `//` +
        window.location.host +
        `/add/vote?id=${index}`;
      fetch(API_URL, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((response) => {
          if (response == "limit votes") {
            localStorage.setItem("userVoted", "0");
          } else {
            localStorage.setItem("userVoted", "1");
            window.location.href = "/galeria";
          }
        })
        .catch(function (error) {});
    }
  };

  return (
    <div className="af-draw-card" data-aos={dataAos}>
      <picture className="af-draw-card__draw" onClick={reanimate}>
        <img src={data.url_image} alt="" title="" />
      </picture>
      <article className="af-draw-card__article">
        <h2 className="af-draw-card__title">{data.draw_title.slice(0, 21)}</h2>
        {/*<h2 className="af-draw-card__name">Artista: {data.name}</h2>*/}
        <section className="af-draw-card__desc">
          <div className="af-draw-card__desc-left">
            <span className="af-draw-card__user-info af-draw-card__user-info--category">
              {data.category}
            </span>
            <span className="af-draw-card__user-info af-draw-card__user-info--school">
              {data.school}
            </span>
            <span className="af-draw-card__user-info af-draw-card__user-info--place">
              {data.place}
            </span>
          </div>
          <div className="af-draw-card__desc-right">
            <div className="af-likes-draw">
              <span className="af-likes-draw__number">{data.votes}</span>
              <button
                className={`af-likes-draw__button ${
                  data.user_voted ? "disableBtn" : ""
                }`}
                onClick={() => handleClickLike(data.id)}
                disabled={isClickLike}
              ></button>
            </div>
            <div className="af-share-container">
              <a className="af-share" href=""></a>
            </div>
          </div>
        </section>
      </article>
    </div>
  );
};

export const DrawPreview = ({ data, onClick, dataAos }: any) => {
  const sendVote = (index: number) => {
    if (window.drupalSettings.user.uid <= 0) {
      window.location.href = "/inicio-sesion";
    } else {
      const API_URL =
        window.location.protocol +
        `//` +
        window.location.host +
        `/add/vote?id=${index}`;
      fetch(API_URL, {
        method: "GET",
      })
        .then((response) => response.json())
        .then((response) => {
          if (response == "limit votes") {
            localStorage.setItem("userVoted", "0");
          } else {
            localStorage.setItem("userVoted", "1");
            window.location.href = "/galeria";
          }
        })
        .catch(function (error) {});
    }
  };
  return (
    <div className="af-draw-preview" data-aos={dataAos}>
      <picture className="af-draw-preview__draw">
        <img src={data.url_image} alt="" title="" />
      </picture>
      <article className="af-draw-preview__article">
        <div className="af-likes-draw af-likes-draw--desk af-likes-draw--reverse">
          <span className="af-likes-draw__number">{data.votes}</span>
          <button
            className={`af-likes-draw__button ${
              data.user_voted ? "disableBtn" : ""
            }`}
            onClick={() => sendVote(data.id)}
          ></button>
        </div>
        <h2 className="af-draw-preview__title">{data.draw_title}</h2>
        {/*<h2 className="af-draw-preview__name">Artista: {data.name}</h2>*/}
        <section className="af-draw-preview__desc">
          <div className="af-draw-preview__desc-left">
            <span className="af-draw-card__user-info af-draw-card__user-info--category">
              {data.category}
            </span>
            <span className="af-draw-card__user-info af-draw-card__user-info--school">
              {data.school}
            </span>
            <span className="af-draw-card__user-info af-draw-card__user-info--place">
              {data.place}
            </span>
          </div>
          <div className="af-draw-preview__desc-right">
            <div className="af-likes-draw af-likes-draw--mob">
              <span className="af-likes-draw__number">{data.votes}</span>
              <button
                className={`af-likes-draw__button ${
                  data.user_voted ? "disableBtn" : ""
                }`}
                onClick={() => sendVote(data.id)}
              ></button>
            </div>
          </div>
          <div className="af-draw-preview__desc-bottom">
            {data.user_voted ? (
              <div className="af-draw-preview__desc-right-2">
                <p className="af-likes-draw__info">Tu voto ya fue registrado</p>
              </div>
            ) : (
              <div className="af-draw-preview__desc-right">
                <button
                  className="af-likes-draw__button2"
                  onClick={() => sendVote(data.id)}
                >
                  Votar
                </button>
              </div>
            )}
            <div
              className={`af-draw-preview__desc-left ${
                data.user_voted ? "votedSucces" : ""
              }`}
            >
              <h5>Compartir</h5>
              <div className="shareIcons">
                <span>
                  <a className="facebookShare">
                    <img
                      src="https://aguasfirmes.s3.amazonaws.com/imgMail/fb.svg"
                      alt="Facebook"
                    />
                  </a>
                  <a className="twitterShare">
                    <img
                      src="https://aguasfirmes.s3.amazonaws.com/imgMail/tw.svg"
                      alt="Facebook"
                    />
                  </a>
                </span>
              </div>
            </div>
          </div>
        </section>
      </article>
    </div>
  );
};
